<button
  type="button"
  appButton
  [name]="name"
  [location]="location"
  [analyticsExtra]="analyticsExtra"
  [color]="checked ? activeColor || 'simple' : 'simple'"
  [spacing]="spacing"
  [hasIcon]="hasIcon"
  [class.full-width]="fullWidth"
  [height]="height"
>
  <ng-content></ng-content>
  <app-radio [checkStyle]="checkStyle" [checked]="checked" [noContent]="true" [simple]="simple"></app-radio>
</button>
